<template>
  <div>
    <file-uploader :compMode="compMode" entite="Member"></file-uploader>

    <div class="card mb-3">
      <div class="card-header" v-if="!prospect">
        <i class="fa fa-user-circle-o"></i>
        <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{
          $t("member.create.title")
        }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{
          $t("member.edit.title")
        }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{
          $t("member.view.title")
        }}</span>
        <toggle-button
          style="margin-left: 20px"
          v-model="member.displayInWebsite"
          :sync="true"
          :width="200"
          :height="30"
          :font-size="14"
          :labels="{
            checked: 'Affiché sur le site web',
            unchecked: 'Masqué sur le site web',
          }"
        />
      </div>
      <div class="card-header" v-if="prospect">
        <i class="fa fa-user-circle"></i>
        <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{
          $t("prospect.create.title")
        }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{
          $t("prospect.edit.title")
        }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{
          $t("prospect.view.title")
        }}</span>
      </div>

      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>

        <form>
          <div class="row" v-if="!prospect">
            <div class="form-group col-md-6">
              <label for="associatedUser"
                >{{ $t("member.form.associateUser") }} (N'est pas l'utilisateur
                pour l'intranet)</label
              >
              <multiselect
                id="associatedUser"
                v-model="selectAssociatedUser"
                track-by="id"
                :customLabel="userSelectLabel"
                :options="userOptions"
                :multiple="false"
                :searchable="true"
                :loading="isLoading"
                :internal-search="true"
                :close-on-select="true"
                :options-limit="10"
                :limit="3"
                :taggable="false"
                :max-height="600"
                :allow-empty="true"
                :show-no-results="true"
                :hide-selected="false"
                placeholder
                v-bind:deselect-label="$t('multiselect.deselect-label')"
                v-bind:selectedLabel="$t('multiselect.selectedLabel')"
                v-bind:select-label="$t('multiselect.select-label')"
                @search-change="usersAsyncFind"
              ></multiselect>
              <span class="text-danger" v-if="errors.has('associatedUser')">{{
                errors.first("associatedUser")
              }}</span>
            </div>
            <!-- <div class="form-group col-md-6">
                        <router-link to="/users/create" class="btn btn-success">{{ $t('member.form.associateNewUser') }}</router-link>
            </div>-->
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">
                  {{ $t("member.form.personalInformations") }}
                </div>
                <div class="card-body">
                  <photo-uploader
                    :compMode="compMode"
                    entite="Member"
                    :fileType="fileType_personProfilePicture"
                    ref="photoUploader"
                  ></photo-uploader>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="nameInput"
                        >{{ $t("member.form.name") }}*</label
                      >
                      <input
                        v-model.trim="member.name"
                        v-validate="'required'"
                        name="name"
                        type="text"
                        class="form-control"
                        id="nameInput"
                        v-bind:placeholder="$t('member.form.name')"
                      />
                      <span class="text-danger" v-if="errors.has('name')">{{
                        errors.first("name")
                      }}</span>
                    </div>

                    <div class="form-group col-md-6">
                      <label for="familyNameInput"
                        >{{ $t("member.form.familyName") }}*</label
                      >
                      <input
                        v-model.trim="member.familyName"
                        v-validate="'required'"
                        name="familyName"
                        type="text"
                        class="form-control"
                        id="familyNameInput"
                        v-bind:placeholder="$t('member.form.familyName')"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('familyName')"
                        >{{ errors.first("familyName") }}</span
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-2">
                      <label for="educationInput">{{
                        $t("member.form.education")
                      }}</label>
                      <select
                        v-model="member.education"
                        class="form-control"
                        id="educationInput"
                      >
                        <option
                          v-for="s in educationLevels"
                          :value="s.item1"
                          :key="s.item1"
                        >
                          {{ s.item2 }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="designation">{{
                        $t("member.form.designation")
                      }}</label>

                      <multiselect
                        v-model="designations"
                        :options="designationOptions"
                        :multiple="true"
                        :taggable="true"
                        @tag="addDesignationTag"
                        v-bind:tag-placeholder="
                          $t('multiselect.tag-placeholder')
                        "
                        v-bind:select-label="$t('multiselect.select-label')"
                        v-bind:placeholder="
                          $t('member.form.designationPlaceHolder')
                        "
                        v-bind:deselect-label="$t('multiselect.deselect-label')"
                        v-bind:selectedLabel="$t('multiselect.selectedLabel')"
                      ></multiselect>

                      <span
                        class="text-danger"
                        v-if="errors.has('designation')"
                        >{{ errors.first("designation") }}</span
                      >
                    </div>
                    <div class="form-group col-md-2">
                      <label for="sex">{{ $t("member.form.sex") }}</label>
                      <select
                        v-model="member.sex"
                        class="form-control"
                        id="sex"
                      >
                        <option
                          v-for="s in sexes"
                          :value="s.item1"
                          :key="s.item1"
                        >
                          {{ s.item2 }}
                        </option>
                      </select>
                      <span class="text-danger" v-if="errors.has('sex')">{{
                        errors.first("sex")
                      }}</span>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="immigrantInput">{{
                        $t("entrepreneur.form.immigrant")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="immigrant"
                            value="1"
                            class="custom-control-input"
                            id="immigrantInput"
                            v-model="member.immigrant"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">Oui</span>
                        </label>
                      </div>
                      <span
                        class="text-danger"
                        v-if="errors.has('immigrant')"
                        >{{ errors.first("immigrant") }}</span
                      >
                    </div>

                    <div class="form-group col-md-2">
                      <label for="languageInput">{{
                        $t("entrepreneur.form.immigrantCountry")
                      }}</label>

                      <multiselect
                        v-model="member.immigrantCountry"
                        :options="immigrantCountrys"
                        :multiple="false"
                        :taggable="false"
                        v-bind:placeholder="
                          $t('entrepreneur.form.immigrantCountry')
                        "
                        v-bind:deselect-label="$t('multiselect.deselect-label')"
                        v-bind:select-label="$t('multiselect.selectedLabel')"
                      ></multiselect>

                      <span
                        class="text-danger"
                        v-if="errors.has('immigrantCountry')"
                        >{{ errors.first("immigrantCountry") }}</span
                      >
                    </div>

                    <div class="form-group col-md-2">
                      <label for="languageInput">{{
                        $t("member.form.nativeLanguage")
                      }}</label>

                      <multiselect
                        v-model="member.nativeLanguage"
                        :options="languageOptions"
                        :multiple="false"
                        :taggable="true"
                        @tag="addLanguageTag"
                        v-bind:tag-placeholder="
                          $t('multiselect.tag-placeholder')
                        "
                        v-bind:deselect-label="$t('multiselect.deselect-label')"
                        v-bind:select-label="$t('multiselect.select-label')"
                        v-bind:selectedLabel="$t('multiselect.selectedLabel')"
                      ></multiselect>

                      <span class="text-danger" v-if="errors.has('language')">{{
                        errors.first("language")
                      }}</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-2">
                      <label for="birthdateInput">{{
                        $t("member.form.birthdate")
                      }}</label>
                      <moment-date-picker
                        v-model="member.birthdate"
                        :required="false"
                      ></moment-date-picker>
                    </div>
                    <div class="form-group col-md-10">
                      <label for="emailInput">
                        {{ $t("member.form.email") }}
                        <span v-if="!prospect">*</span>
                      </label>
                      <input
                        v-model.trim="member.email"
                        v-validate="!prospect ? 'required|email' : ''"
                        name="email"
                        type="text"
                        class="form-control"
                        id="emailInput"
                        v-bind:placeholder="$t('member.form.email')"
                      />
                      <span class="text-danger" v-if="errors.has('email')">{{
                        $t("validations.required_email")
                      }}</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-2">
                      <label for="preAuthorizedDebit">{{
                        $t("member.form.preAuthorizedDebit")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="preAuthorizedDebit"
                            value="1"
                            class="custom-control-input"
                            id="preAuthorizedDebit"
                            v-model="member.preAuthorizedDebit"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="cellphoneInput">
                        {{ $t("member.form.cellphone") }}
                        <span v-if="!prospect">*</span>
                      </label>
                      <input
                        v-model.trim="member.cellphone"
                        v-mask="'(###) ###-####'"
                        v-validate="
                          !prospect
                            ? { rules: { required: true, regex: phoneRegex() } }
                            : {}
                        "
                        name="cellphone"
                        type="text"
                        class="form-control"
                        id="cellphoneInput"
                        placeholder="(999) 999-9999"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('cellphone')"
                        >{{ $t("validations.requiredPhone") }}</span
                      >
                    </div>
                    <div class="form-group col-md-2">
                      <label for="phoneInput">{{
                        $t("member.form.phone")
                      }}</label>
                      <input
                        v-model.trim="member.phone"
                        v-mask="'(###) ###-####'"
                        v-validate="{
                          rules: { required: false, regex: phoneRegex() },
                        }"
                        name="phone"
                        type="text"
                        class="form-control"
                        id="phoneInput"
                        placeholder="(999) 999-9999"
                      />
                      <span class="text-danger" v-if="errors.has('phone')">{{
                        errors.first("phone")
                      }}</span>
                    </div>

                    <div class="form-group col-md-2">
                      <label for="officePhoneInput">{{
                        $t("member.form.officePhone")
                      }}</label>
                      <input
                        v-model.trim="member.officePhone"
                        v-mask="'(###) ###-####'"
                        v-validate="{
                          rules: { required: false, regex: phoneRegex() },
                        }"
                        name="officePhone"
                        type="text"
                        class="form-control"
                        id="officePhoneInput"
                        placeholder="(999) 999-9999"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('officePhone')"
                        >{{ errors.first("officePhone") }}</span
                      >
                    </div>

                    <div class="form-group col-md-1">
                      <label for="officePhoneExtensionInput">{{
                        $t("member.form.officePhoneExtension")
                      }}</label>
                      <input
                        v-model.trim="member.officePhoneExtension"
                        name="officePhoneExtension"
                        maxlength="10"
                        type="text"
                        class="form-control"
                        id="officePhoneExtensionInput"
                        v-bind:placeholder="
                          $t('member.form.officePhoneExtensionPH')
                        "
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('officePhoneExtension')"
                        >{{ errors.first("officePhoneExtension") }}</span
                      >
                    </div>
                    <div class="form-group col-md-2">&nbsp;</div>
                    <div class="form-group col-md-1">
                      <label for="wordpress">{{
                        $t("social.wordpress")
                      }}</label>
                      <input
                        v-model.trim="member.social.wordpress"
                        name="wordpress"
                        maxlength="3"
                        type="number"
                        class="form-control"
                        id="wordpress"
                        v-bind:placeholder="$t('social.wordpress')"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('wordpress')"
                        >{{ errors.first("wordpress") }}</span
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="introduction">{{
                        $t("member.form.introduction")
                      }}</label>
                       <ckeditor
                        :editor="editor"
                        v-model.trim="introductionInitialize"
                        name="introduction"
                        id="introduction"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="introduction_en">{{
                        $t("member.form.introduction_en")
                      }}</label>
                      <ckeditor
                        :editor="editor"
                        v-model.trim="introductionEnInitialize"
                        name="introduction_en"
                        id="introduction_en"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="biography">{{
                        $t("member.form.biography")
                      }}</label>
                     <ckeditor
                        :editor="editor"
                        v-model.trim="biographyInitialize"
                        name="biography"
                        id="biography"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="biography_en">{{
                        $t("member.form.biography_en")
                      }}</label>
                    <ckeditor
                        :editor="editor"
                        v-model.trim="biographyEnInitialize"
                        name="biography_en"
                        id="biography_en"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <address-component
            v-bind:address="member.address"
            :required="!prospect"
          ></address-component>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">
                  {{ $t("member.form.membershipTitle") }}
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for="meetingLocation">{{
                        $t("member.form.meetingLocation")
                      }}</label>
                      <select
                        v-model="member.meetingLocation"
                        class="form-control"
                        id="meetingLocation"
                      >
                        <option
                          v-for="l in locations"
                          :value="l.key"
                          :key="l.key"
                        >
                          {{ l.value }}
                        </option>
                      </select>
                      <span
                        class="text-danger"
                        v-if="errors.has('meetingLocation')"
                        >{{ errors.first("meetingLocation") }}</span
                      >
                    </div>
                    <div class="form-group col-md-4">
                      <label for="memberType"
                        >{{ $t("member.form.type") }}*</label
                      >
                      <input
                        type="hidden"
                        name="type_validate"
                        v-model="type_validate"
                        v-validate="'required'"
                      />
                      <select
                        v-model="member.type"
                        class="form-control"
                        id="memberType"
                        name="memberType"
                      >
                        <option
                          v-for="t in memberTypes"
                          :value="t.key"
                          :key="t.key"
                        >
                          {{ t.value }}
                        </option>
                      </select>
                      <span
                        class="text-danger"
                        v-if="errors.has('type_validate')"
                        >{{ $t("validations.required") }}</span
                      >
                    </div>
                    <div class="form-group col-md-4">
                      <label for="memberStatus"
                        >{{ $t("member.form.status") }}*</label
                      >
                      <input
                        type="hidden"
                        name="status_validate"
                        v-model="status_validate"
                        v-validate="'required'"
                      />
                      <select
                        v-model="member.status"
                        class="form-control"
                        id="memberStatus"
                        name="memberStatus"
                      >
                        <option
                          v-for="s in memberStatus"
                          :value="s.key"
                          :key="s.key"
                        >
                          {{ s.value }}
                        </option>
                      </select>
                      <span
                        class="text-danger"
                        v-if="errors.has('status_validate')"
                        >{{ $t("validations.required") }}</span
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-4" v-if="member.type != 2">
                      <label for="memberSince">{{
                        $t("member.form.memberSince")
                      }}</label>
                      <moment-date-picker
                        v-model="member.memberSince"
                        :required="false"
                      ></moment-date-picker>
                    </div>
                    <div class="form-group col-md-4" v-if="member.type != 2">
                      <label for="membershipRenewalDate">{{
                        $t("member.form.membershipRenewalDate")
                      }}</label>
                      <moment-date-picker
                        v-model="member.membershipRenewalDate"
                        :required="false"
                      ></moment-date-picker>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="memberPrincing">{{
                        $t("member.form.pricing")
                      }}</label>
                      <select
                        v-model="member.pricing"
                        class="form-control"
                        id="memberPrincing"
                      >
                        <option
                          v-for="p in memberPricing"
                          :value="p.key"
                          :key="p.key"
                        >
                          {{ p.value }}
                        </option>
                      </select>
                      <span
                        class="text-danger"
                        v-if="errors.has('memberPrincing')"
                        >{{ errors.first("memberPrincing") }}</span
                      >
                    </div>
                  </div>
                  <div class="row" v-if="member.type != 2">
                    <div class="form-group col-md-4">
                      <label for="membershipCancellationDate">{{
                        $t("member.form.membershipCancellationDate")
                      }}</label>
                      <moment-date-picker
                        v-model="member.membershipCancellationDate"
                        :required="false"
                      ></moment-date-picker>
                    </div>
                    <div class="form-group col-md-8">
                      <label for="membershipCancellationReason">{{
                        $t("member.form.membershipCancellationReason")
                      }}</label>

                      <select
                        v-model="member.membershipCancellationReason"
                        class="form-control"
                        id="membershipCancellationReason"
                      >
                        <option
                          v-for="p in membershipCancellationReasons"
                          :value="p.item1"
                          :key="p.item2"
                        >
                          {{ p.item2 }}
                        </option>
                      </select>

                      <span
                        class="text-danger"
                        v-if="errors.has('membershipCancellationReason')"
                        >{{
                          errors.first("membershipCancellationReason")
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <createMemberAction
            :compMode="actionMode"
            :type="member.type"
            :actions="member.actions"
            @memberTypeChanged="memberTypeChanged"
          ></createMemberAction>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">
                  {{ $t("member.form.junior.title") }}
                  <div class="float-right">
                    <a
                      href="#junior"
                      name="junior"
                      v-on:click="expandOrCollapseJunior"
                    >
                      <span
                        class="fa fa-expand fa-lg"
                        v-if="!juniorVisible"
                      ></span>
                      <span
                        class="fa fa-compress fa-lg"
                        v-if="juniorVisible"
                      ></span>
                    </a>
                  </div>
                </div>
                <div class="card-body" v-if="juniorVisible">
                  <div class="row">
                    <div class="form-group col-md-3">
                      <label for="subscribedToNewsletter">{{
                        $t("member.form.junior.parentalAuthorization")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="parentalAuthorization"
                            value="1"
                            class="custom-control-input"
                            id="parentalAuthorization"
                            v-model="member.parentalAuthorization"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="conductCode">{{
                        $t("member.form.junior.conductCode")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="conductCode"
                            value="1"
                            class="custom-control-input"
                            id="conductCode"
                            v-model="member.conducttCode"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="interview">{{
                        $t("member.form.junior.interview")
                      }}</label>
                      <moment-date-picker
                        v-model="member.interview"
                        :required="false"
                      ></moment-date-picker>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="interview">{{
                        $t("member.form.junior.formation")
                      }}</label>
                      <moment-date-picker
                        v-model="member.formation"
                        :required="false"
                      ></moment-date-picker>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="godfatherId">{{
                        $t("member.form.godfatherId")
                      }}</label>
                      <multiselect
                        id="godfatherId"
                        v-model="member.godfatherId"
                        :options="memberOptions"
                        :multiple="false"
                        :taggable="false"
                        :customLabel="memberSelectLabel"
                        v-bind:tag-placeholder="
                          $t('multiselect.tag-placeholder')
                        "
                        v-bind:select-label="$t('multiselect.select-label')"
                        placeholder
                        v-bind:deselect-label="$t('multiselect.deselect-label')"
                        v-bind:selectedLabel="$t('multiselect.selectedLabel')"
                      ></multiselect>
                      <span
                        class="text-danger"
                        v-if="errors.has('godfatherId')"
                        >{{ errors.first("godfatherId") }}</span
                      >
                    </div>
                    <div class="form-group col-md-6">
                      <label for="cohortNumber">{{
                        $t("member.form.cohortNumber")
                      }}</label>
                      <input
                        v-model="member.cohortNumber"
                        class="form-control"
                        id="cohortNumber"
                        type="number"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('cohortNumber')"
                        >{{ errors.first("cohortNumber") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">{{ $t("member.form.refTitle") }}</div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="applicationSource">{{
                        $t("member.form.applicationSource")
                      }}</label>

                      <select
                        v-model="member.applicationSource"
                        class="form-control"
                        id="applicationSource"
                      >
                        <option
                          v-for="p in applicationSources"
                          :value="p.item1"
                          :key="p.item2"
                        >
                          {{ p.item2 }}
                        </option>
                      </select>

                      <span
                        class="text-danger"
                        v-if="errors.has('applicationSource')"
                        >{{ errors.first("applicationSource") }}</span
                      >
                    </div>

                    <div class="form-group col-md-6">
                      <label for="referredByMemberId">{{
                        $t("member.form.referredByMemberId")
                      }}</label>
                      <multiselect
                        id="referredByMemberId"
                        v-model="member.referredByMemberId"
                        :options="memberOptions"
                        :multiple="false"
                        :taggable="false"
                        :customLabel="memberSelectLabel"
                        v-bind:tag-placeholder="
                          $t('multiselect.tag-placeholder')
                        "
                        v-bind:select-label="$t('multiselect.select-label')"
                        placeholder
                        v-bind:deselect-label="$t('multiselect.deselect-label')"
                        v-bind:selectedLabel="$t('multiselect.selectedLabel')"
                      ></multiselect>
                      <span
                        class="text-danger"
                        v-if="errors.has('referredByMemberId')"
                        >{{ errors.first("referredByMemberId") }}</span
                      >
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="applicationSource">{{
                        $t("member.form.recruiterType")
                      }}</label>

                      <select
                        v-model="member.recruiterType"
                        class="form-control"
                        id="recruiterType"
                      >
                        <option value="1">{{ $t("user.user") }}</option>
                        <option value="2">
                          {{ $t("member.form.relation.member") }}
                        </option>
                      </select>

                      <span
                        class="text-danger"
                        v-if="errors.has('applicationSource')"
                        >{{ errors.first("applicationSource") }}</span
                      >
                    </div>

                    <div
                      class="form-group col-md-6"
                      v-if="member.recruiterType == 2"
                    >
                      <label for="referredByMemberId">{{
                        $t("member.form.recruiter")
                      }}</label>
                      <multiselect
                        id="recruiterMember"
                        v-model="member.recruiterMemberId"
                        :options="memberOptions"
                        :multiple="false"
                        :taggable="false"
                        :customLabel="memberSelectLabel"
                        v-bind:tag-placeholder="
                          $t('multiselect.tag-placeholder')
                        "
                        v-bind:select-label="$t('multiselect.select-label')"
                        :placeholder="$t('member.form.relation.member')"
                        v-bind:deselect-label="$t('multiselect.deselect-label')"
                        v-bind:selectedLabel="$t('multiselect.selectedLabel')"
                      ></multiselect>
                      <span
                        class="text-danger"
                        v-if="errors.has('recruiterMember')"
                        >{{ errors.first("recruiterMember") }}</span
                      >
                    </div>

                    <div
                      class="form-group col-md-6"
                      v-if="member.recruiterType == 1"
                    >
                      <label for="recruiterUser">{{
                        $t("member.form.recruiter")
                      }}</label>
                      <multiselect
                        v-model="member.recruiterUser"
                        id="ajax"
                        :custom-label="userSelectLabel"
                        track-by="id"
                        :placeholder="$t('user.user')"
                        open-direction="bottom"
                        :options="userOptions"
                        :multiple="false"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :clear-on-select="true"
                        :close-on-select="true"
                        :options-limit="300"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="usersAsyncFind"
                        :select-label="$t('multiselect.select-label')"
                      >
                        <span slot="noResult">{{
                          $t("multiselect.not-found")
                        }}</span>
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <createMemberCompetency
            :compMode="compMode"
            :competencys="member.competencys"
          ></createMemberCompetency>

          <createMemberRelation
            :compMode="compMode"
            :id="member.id"
            :members="members"
            :relations="member.relations"
          ></createMemberRelation>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">
                  {{ $t("member.form.socialTitle") }}
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label for="socialNetworkInput">{{
                        $t("social.socialNetworks")
                      }}</label>
                      <!-- Don't need this anymore i think, waiting on isabelle. -->
                      <!-- <multiselect
                        v-model="member.social.socialNetworks"
                        :options="socialNetworks"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :hide-selected="true"
                        :preserve-search="true"
                        v-bind:placeholder="$t('social.socialNetworks')"
                        :preselect-first="true"
                      ></multiselect>
                      <span
                        class="text-danger"
                        v-if="errors.has('socialNetworks')"
                      >{{ errors.first('socialNetworks') }}</span> -->
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-3">
                      <label for="facebook">{{
                        $t("social.facebookLink")
                      }}</label>
                      <input
                        type="text"
                        id="facebook"
                        v-model.trim="member.facebook"
                        name="facebook"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="linkedIn">{{
                        $t("social.linkedInLink")
                      }}</label>
                      <input
                        type="text"
                        id="linkedIn"
                        v-model.trim="member.linkedIn"
                        name="linkedIn"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="twitter">{{
                        $t("social.twitterLink")
                      }}</label>
                      <input
                        type="text"
                        id="twitter"
                        v-model.trim="member.twitter"
                        name="twitter"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="website">{{
                        $t("social.websiteLink")
                      }}</label>
                      <input
                        type="text"
                        id="website"
                        v-model.trim="member.website"
                        name="website"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-3">
                      <label for="subscribedToNewsletter">{{
                        $t("member.form.subscribedToNewsletter")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="subscribedToNewsletter"
                            value="1"
                            class="custom-control-input"
                            id="subscribedToNewsletter"
                            v-model="member.subscribedToNewsletter"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                      <span
                        class="text-danger"
                        v-if="errors.has('subscribedToNewsletter')"
                        >{{ errors.first("subscribedToNewsletter") }}</span
                      >
                    </div>

                    <div class="form-group col-md-3">
                      <label for="emailAQ">{{
                        $t("member.form.emailAQ")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="emailAQ"
                            value="1"
                            class="custom-control-input"
                            id="emailAQ"
                            v-model="member.emailAQ"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                      <span class="text-danger" v-if="errors.has('emailAQ')">{{
                        errors.first("emailAQ")
                      }}</span>
                    </div>

                    <div class="form-group col-md-3">
                      <label for="autorisationBio">{{
                        $t("member.form.autorisationBio")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="autorisationBio"
                            value="1"
                            class="custom-control-input"
                            id="autorisationBio"
                            v-model="member.autorisationBio"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                      <span
                        class="text-danger"
                        v-if="errors.has('autorisationBio')"
                        >{{ errors.first("autorisationBio") }}</span
                      >
                    </div>

                    <div class="form-group col-md-3">
                      <label for="photoConsent">{{
                        $t("member.form.photoConsent")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="photoConsent"
                            value="1"
                            class="custom-control-input"
                            id="photoConsent"
                            v-model="member.photoConsent"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                      <span
                        class="text-danger"
                        v-if="errors.has('photoConsent')"
                        >{{ errors.first("photoConsent") }}</span
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-3">
                      <label for="businessCardAQ">{{
                        $t("member.form.businessCardAQ")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="businessCardAQ"
                            value="1"
                            class="custom-control-input"
                            id="businessCardAQ"
                            v-model="member.businessCardAQ"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                      <span
                        class="text-danger"
                        v-if="errors.has('businessCardAQ')"
                        >{{ errors.first("businessCardAQ") }}</span
                      >
                    </div>

                    <div class="form-group col-md-3">
                      <label for="followFacebook">{{
                        $t("social.followFacebook")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="followFacebook"
                            value="1"
                            class="custom-control-input"
                            id="followFacebook"
                            v-model="member.social.followFacebook"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                      <span
                        class="text-danger"
                        v-if="errors.has('followFacebook')"
                        >{{ errors.first("followFacebook") }}</span
                      >
                    </div>

                    <div class="form-group col-md-3">
                      <label for="followLinkedinGroup">{{
                        $t("social.followLinkedinGroup")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="followLinkedinGroup"
                            value="1"
                            class="custom-control-input"
                            id="followLinkedinGroup"
                            v-model="member.social.followLinkedinGroup"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                      <span
                        class="text-danger"
                        v-if="errors.has('followLinkedinGroup')"
                        >{{ errors.first("followLinkedinGroup") }}</span
                      >
                    </div>

                    <div class="form-group col-md-3">
                      <label for="followLinkedinProfile">{{
                        $t("social.followLinkedinProfile")
                      }}</label>
                      <div class="col-9">
                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="followLinkedinProfile"
                            value="1"
                            class="custom-control-input"
                            id="followLinkedinProfile"
                            v-model="member.social.followLinkedinProfile"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">{{
                            $t("yes")
                          }}</span>
                        </label>
                      </div>
                      <span
                        class="text-danger"
                        v-if="errors.has('followLinkedinProfile')"
                        >{{ errors.first("followLinkedinProfile") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <view-event-person
            v-if="compMode == CRUDMODE.READ"
            :memberId="member.id"
          ></view-event-person>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">{{ $t("intranet.title") }}</div>
                <div class="card-body">
                  <label class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      name="private"
                      value="1"
                      class="custom-control-input"
                      id="private"
                      v-model="member.private"
                    />
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-label">{{
                      $t("intranet.privateProfile")
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div
            class="card font-weight-bold text-uppercase bg-warning mb-3"
            v-if="member.imported && compMode == CRUDMODE.UPDATE"
          >
            <div class="card-body">
              <label class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  name="lead"
                  value="1"
                  class="custom-control-input"
                  id="removeImportedFlag"
                  v-model="member.removeImportedFlag"
                />
                <span class="custom-control-indicator"></span>
                <span class="custom-control-label">{{
                  $t("removeImportedFlag")
                }}</span>
              </label>
            </div>
          </div>

          <a
            @click="createMember"
            v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY"
            id="addButton"
            class="btn btn-primary"
            >{{ $t("form.create_button") }}</a
          >

          <a
            @click="editMember"
            v-if="compMode == CRUDMODE.UPDATE"
            id="editButton"
            class="btn btn-primary"
            >{{ $t("form.edit_button") }}</a
          >
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  MemberServiceClient,
  PersonServiceClient,
  UserServiceClient,
  AddressServiceClient,
  EntrepreneurServiceClient,
  MemberDto,
  AddressDto,
  UserDto,
  SocialDto,
  LocalizableStringDto,
  LocalizableString,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'
import AddressComponent from '../Address.vue'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import Enum from '@/shared/enum'
import designations from '@/shared/designations'
import MomentDatePicker from '../../shared/components/MomentDatePicker'
import CreateMemberAction from './CreateMemberAction'
import CreateMemberRelation from './CreateMemberRelation'
import CreateMemberCompetency from './CreateMemberCompetency'
import ViewEventPerson from '../events/ViewEventPerson'
import PhotoUploader from '../../shared/components/PhotoUploader.vue'
import {ToggleButton} from 'vue-js-toggle-button'

export default {
  name: 'CreateMember',
  mixins: [CrudMixin],
  props: {
    prospect: false,
  },
  data() {
    let dto = new MemberDto()
    dto.init({})
    dto.displayInWebsite = true
    dto.address = new AddressDto()
    dto.address.init({})
    dto.actions = []
    dto.relations = []
    dto.competencys = []
    dto.social = new SocialDto()
    dto.social.init({})
    dto.biography = new LocalizableStringDto()
    dto.introduction = new LocalizableStringDto()
    //  dto.biography.init({})
    //   dto.introduction.init({})

    return {
      isLoading: false,
      ready: false,
      error: '',
      educationLevels: [],
      sexes: [],
      member: dto,
      languageOptions: ['Français', 'Anglais', 'Espagnol'],
      designationOptions: designations,
      designations: [],
      memberTypes: [],
      memberStatus: [],
      locations: [],
      regions: [],
      memberPricing: [],
      members: [],
      memberOptions: [],
      userOptions: [],
      referredByMember: null,
      godfather: null,
      selectAssociatedUser: null,
      juniorVisible: false,
      socialNetworks: ['LinkedIn', 'Facebook', 'Twitter', 'Instagram', 'Slack'],
      immigrantCountrys: [],
      membershipCancellationReasons: [],
      applicationSources: [],
      photo: '',
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'link',
            '|',
            'outdent',
            'indent',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'insertTable',
            '|',
            'blockQuote',
            '|',
            'undo',
            'redo',
            'removeFormat',
          ],
        },
      },
    }
  },
  mounted: function() {},
  computed: {
    fileType_personProfilePicture: function() {
      return Enum.FileType.PERSONPROFILEPICTURE
    },
    type_validate: function() {
      return this.member.type
    },
    status_validate: function() {
      return this.member.status
    },
    actionMode: function() {
      if (this.member.type == 2) return this.compMode
      else return Enum.Mode.READ
    },
    biographyInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.member.biography.french == null) {
          return ' '
        }
        return this.member.biography.french
      },
      // setter
      set: function(newValue) {
        this.member.biography.french = newValue
      },
    },
    biographyEnInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.member.biography.english == null) {
          return ' '
        }
        return this.member.biography.english
      },
      // setter
      set: function(newValue) {
        this.member.biography.english = newValue
      },
    },
    introductionInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.member.introduction.french == null) {
          return ' '
        }
        return this.member.introduction.french
      },
      // setter
      set: function(newValue) {
        console.log(this.data)
        this.member.introduction.french = newValue
      },
    },
    introductionEnInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.member.introduction.english == null) {
          return ' '
        }
        return this.member.introduction.english
      },
      // setter
      set: function(newValue) {
        this.member.introduction.english = newValue
      },
    },
  },
  watch: {
    type_validate: function(newVal) {
      this.juniorVisible = newVal == 3
    },
    designations: function(newVal, oldVal) {
      this.member.designation = newVal.join()
    },
    referredByMember: function(newVal, oldVal) {
      this.member.referredByMemberId = newVal.id
    },
    godfather: function(newVal, oldVal) {
      this.member.referredByMemberId = newVal.id
    },
    selectAssociatedUser: function(newVal, oldVal) {
      if (newVal == null) {
        this.member.associatedUserJunior = null
        this.member.associatedUserJuniorId = null
      } else {
        let userDto = new UserDto()
        userDto.init(newVal)

        this.member.associatedUserJunior = userDto
        this.member.associatedUserJuniorId = userDto.id
      }
    },
    prospect: {
      handler: function(newVal) {
        if (newVal && this.member.type == null) {
          this.member.type = 2
          this.member.status = 2
        }
      },
      immediate: true,
    },
  },
  methods: {
    memberTypeChanged: function(type) {
      if (type == 11) {
        //Abandon
        this.member.status = 6
      } else if (type == 10) {
        //Suspend
        this.member.status = 5
      }
    },
    expandOrCollapseJunior: function() {
      this.juniorVisible = !this.juniorVisible
    },
    manageEntity: function() {
      let cleanMember = this.cleanFields(this.member)

      if (cleanMember.actions != null) {
        for (var ix = 0; ix < cleanMember.actions.length; ix++) {
          cleanMember.actions[ix].forMember = null
          cleanMember.actions[ix].byUser = null
        }
      } else {
        cleanMember.actions = []
      }

      if (cleanMember.relations != null) {
        for (var ix = 0; ix < cleanMember.relations.length; ix++) {
          cleanMember.relations[ix].isMember = null
        }
      } else {
        cleanMember.relations = []
      }

      if (cleanMember.recruiterUser != null) {
        cleanMember.recruiterUserId = cleanMember.recruiterUser.id
        cleanMember.recruiterUser = null
      }

      return cleanMember
    },
    handlePhotoUpload() {
      this.photo = this.$refs.photo.files[0]
    },
    createMember: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && self.ready) {
            let memberService = ServiceFactory.create(MemberServiceClient)

            memberService
              .create(self.manageEntity())
              .then(function(res) {
                self.persistFiles(res.id)
                self.$refs.photoUploader.persistPhoto(res.id)
              })
              .then(res => {
                this.$swal('Succès', self.member.type == 2 ? this.$t('prospect.create.succes') : this.$t('member.create.succes'), 'success')
                self.redirect()
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            $('html, body')
              .stop()
              .animate({scrollTop: 0}, 1000, 'easeInOutExpo')

            self.error = this.$i18n.t('validations.formErrors')
            //self.errors
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editMember: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this
          if (result && self.ready) {
            let MemberService = ServiceFactory.create(MemberServiceClient)
            MemberService.update(self.manageEntity())
              .then(function(res) {
                self.persistFiles(res.id)
                self.$refs.photoUploader.persistPhoto(res.id)
              })
              .then(res => {
                this.$swal('Succès', self.member.type == 2 ? this.$t('prospect.edit.succes') : this.$t('member.edit.succes'), 'success')
                self.redirect()
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            self.errors
          }
        })
        .catch(err => {
          err
        })
    },
    redirect: function() {
      if (this.member.type == 2) this.$router.push({path: '/prospects'})
      else this.$router.push({path: '/members'})
    },
    fetchData: function() {
      let entrepreneurService = ServiceFactory.create(EntrepreneurServiceClient)
      let personService = ServiceFactory.create(PersonServiceClient)
      let memberService = ServiceFactory.create(MemberServiceClient)
      let addressService = ServiceFactory.create(AddressServiceClient)

      let self = this
      let promisseAll

      let getSexes = personService.getSexes()
      let getEducations = personService.getEducations()
      let getPricing = memberService.getPricing()
      let getLocations = addressService.getLocations()
      let getStatus = memberService.getStatus()
      let getTypes = memberService.getTypes()
      let getMembers = memberService.getAll(8, '', '', 0, 1000)
      let getImmigrantCountrys = entrepreneurService.getCountrys() // memberService.getCountrys()
      let getMembershipCancellationReasons = memberService.getMembershipCancellationReasons()
      let getApplicationSources = memberService.getApplicationSources()

      getApplicationSources
        .then(res => {
          self.applicationSources = res
        })
        .catch(err => {
          console.log(err)
        })

      getMembershipCancellationReasons
        .then(res => {
          self.membershipCancellationReasons = res
        })
        .catch(err => {
          console.log(err)
        })

      getImmigrantCountrys
        .then(res => {
          self.immigrantCountrys = res
        })
        .catch(err => {
          console.log(err)
        })
      getSexes
        .then(res => {
          self.sexes = res
        })
        .catch(err => {
          err
        })

      getEducations
        .then(res => {
          self.educationLevels = res
        })
        .catch(err => {
          err
        })

      getTypes
        .then(res => {
          self.memberTypes = res

          if (self.prospect)
            self.memberTypes = _.filter(self.memberTypes, f => {
              return f.key == 2
            })
        })
        .catch(err => {
          err
        })

      getStatus
        .then(res => {
          if (!self.prospect) {
            self.memberStatus = _.filter(res, x => x.key != 5 && x.key != 6)
          } else {
            self.memberStatus = res
          }
        })
        .catch(err => {
          err
        })

      getLocations
        .then(res => {
          this.locations = res
        })
        .catch(err => {
          err
        })

      getPricing
        .then(res => {
          this.memberPricing = res
        })
        .catch(err => err)

      getMembers
        .then(res => {
          this.members = res.items
          this.memberOptions = _.map(res.items, 'id')
        })
        .catch(err => err)

      if (this.compMode != Enum.Mode.CREATE) {
        let getMember = memberService.get(this.$route.params.id)
        getMember
          .then(res => {
            self.member = res
            self.selectAssociatedUser = res.associatedUserJunior

            if (self.member.actions == null) self.member.actions = []
            if (self.member.relations == null) self.member.relations = []
            if (self.member.competencys == null) self.member.competencys = []
            if (self.member.social == null) self.member.social = new SocialDto({})

            self.checkCopyMode(self.member)
          })
          .catch(err => {
            err
          })

        promisseAll = Promise.all([
          getSexes,
          getEducations,
          getImmigrantCountrys,
          getTypes,
          getStatus,
          getLocations,
          getPricing,
          getMembers,
          getMember,
          getMembershipCancellationReasons,
          getApplicationSources,
        ])
      } else {
        promisseAll = Promise.all([
          getSexes,
          getEducations,
          getImmigrantCountrys,
          getTypes,
          getStatus,
          getLocations,
          getPricing,
          getMembers,
          getMembershipCancellationReasons,
          getApplicationSources,
        ])
      }

      promisseAll.then(v => {
        self.ready = true

        if (self.member.type != 2)
          self.memberTypes = _.filter(self.memberTypes, x => {
            return x.key != 2
          })
      })
    },
    addLanguageTag: function(tag) {
      this.languageOptions.push(tag)
      this.member.nativeLanguage = tag
    },
    addDesignationTag: function(tag) {
      this.designationOptions.push(tag)
      this.designations.push(tag)
    },
    memberSelectLabel: function(option) {
      let member = _.find(this.members, x => x.id == option)

      if (member) {
        return member.id + ' - ' + member.name + ' ' + member.familyName
      }

      return ''
    },
    usersAsyncFind: function(query) {
      if (query.length > 0) {
        this.isLoading = true
        let service = ServiceFactory.create(UserServiceClient)

        let self = this
        service.getAutocomplete(query).then(response => {
          self.userOptions = _.map(response, user => {
            let userDto = new UserDto()
            userDto.init(user)
            return userDto
          })

          if (self.selectAssociatedUser && !self.userOptions.length) {
            self.userOptions = [self.selectAssociatedUser]
          }

          self.isLoading = false
        })
      }
    },
    userSelectLabel: function(option) {
      return option.id + ' - ' + option.firstName + ' ' + option.lastName
    },
  },
  components: {
    errorMessage: ErrorMessage,
    AddressComponent: AddressComponent,
    multiselect: Multiselect,
    CreateMemberAction,
    CreateMemberRelation,
    CreateMemberCompetency,
    'moment-date-picker': MomentDatePicker,
    ViewEventPerson,
    'photo-uploader': PhotoUploader,
    ToggleButton,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.btn-primary {
  color: #fff !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/members/CreateMember.vue